const PREFIX = 'measurementList';

function read<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

function write(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable — the list still works for this session.
  }
}

const hiddenKey = (userId: string) => `${PREFIX}:${userId}:hidden`;

export const loadHidden = (userId: string) =>
  new Set(read<string[]>(hiddenKey(userId)) ?? []);

export const saveHidden = (userId: string, hidden: Set<string>) =>
  write(hiddenKey(userId), [...hidden]);

// Annotations that start hidden (A4C AI lines) and the reader chose to show.
const shownKey = (userId: string) => `${PREFIX}:${userId}:shown`;

export const loadShown = (userId: string) =>
  new Set(read<string[]>(shownKey(userId)) ?? []);

export const saveShown = (userId: string, shown: Set<string>) =>
  write(shownKey(userId), [...shown]);
